function AdminSchoolLocationViewVehiclesController($state, $stateParams, LocationsModel) {

}
AdminSchoolLocationViewVehiclesController.$inject = ['$state', '$stateParams', 'LocationsModel']
export default AdminSchoolLocationViewVehiclesController;